import { Component, ViewChild, inject } from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from "../../shared/pipes/translate.pipe";
import {LanguageService} from "../../shared/services/language.service";
import {HeadlineComponent} from "../../shared/elements/headline/headline.component";
import {IconBadgeComponent} from "../../shared/elements/icon-badge/icon-badge.component";
import {FormInputComponent} from "../../shared/elements/form-input/form-input.component";
import {FormBuilder, FormGroup} from '@angular/forms';
import {FormButtonComponent} from "../../shared/elements/form-button/form-button.component";
import {DialogComponent} from '@syncfusion/ej2-angular-popups';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import {FormDropdownComponent} from "../../shared/elements/form-dropdown/form-dropdown.component";
import {ToastModule} from '@syncfusion/ej2-angular-notifications';
import {TYPE} from "../../shared/types/types";
import {LayoutService} from "../../shared/services/layout.service";
import {AvatarComponent} from "../../shared/elements/avatar/avatar.component";
import {TooltipModule} from "@syncfusion/ej2-angular-popups";
import {TooltipComponent} from "../../shared/elements/tooltip/tooltip.component";
import {DialogService} from "../../shared/services/dialog.service";
import {StepHeaderComponent} from "../../shared/elements/step-header/step-header.component";
import {StepContentComponent} from "../../shared/elements/step-content/step-content.component";
import {FormLabelComponent} from "../../shared/elements/form-label/form-label.component";
import {FormTextareaComponent} from "../../shared/elements/form-textarea/form-textarea.component";
import {FormUserGroupMailComponent} from "../../shared/elements/form-user-group-mail/form-user-group-mail.component";
import {FormCheckboxComponent} from "../../shared/elements/form-checkbox/form-checkbox.component";
import {FormDateTimeComponent} from "../../shared/elements/form-date-time/form-date-time.component";
import {FormDateComponent} from "../../shared/elements/form-date/form-date.component";
import {FormNumericComponent} from "../../shared/elements/form-numeric/form-numeric.component";
import {FormRadioComponent} from "../../shared/elements/form-radio/form-radio.component";
import {ContentComponent} from "../../shared/elements/content/content.component";
import {SliderModule, RatingModule} from '@syncfusion/ej2-angular-inputs';
import { TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import {FormSwitchComponent} from "../../shared/elements/form-switch/form-switch.component";
import {DialogDocumentsUploadComponent} from "../../modules/documents/dialog-documents-upload/dialog-documents-upload.component";
import {RouterService} from "../../shared/services/router.service";
import {PillComponent} from "../../shared/elements/pill/pill.component";
import { FileStorageResource } from '../../shared/types/generated/fileStorageResource';
import {NgSrcImageErrorDirective} from '../../shared/directives/ng-src-image-error.directive';

@Component({
    selector: 'app-workflows-createsd',
    imports: [
        CommonModule,
        DialogModule,
        TranslatePipe,
        HeadlineComponent,
        FormInputComponent,
        FormButtonComponent,
        FormDropdownComponent,
        ToastModule,
        IconBadgeComponent,
        AvatarComponent,
        TooltipModule,
        TooltipComponent,
        StepHeaderComponent,
        StepContentComponent,
        FormLabelComponent,
        FormTextareaComponent,
        FormUserGroupMailComponent,
        FormCheckboxComponent,
        FormDateTimeComponent,
        FormNumericComponent,
        FormRadioComponent,
        ContentComponent,
        SliderModule,
        RatingModule,
        FormDateComponent,
        TimePickerModule,
        FormSwitchComponent,
        DialogDocumentsUploadComponent,
        PillComponent,
        NgSrcImageErrorDirective
    ],
    templateUrl: './workflows-createsd.component.html',
    styleUrl: './workflows-createsd.component.scss'
})
export class WorkflowsSDCreate {
  layoutService = inject(LayoutService);
  private formBuilder = inject(FormBuilder);
  private languageService = inject(LanguageService);
  dialogService = inject(DialogService);
  routerService = inject(RouterService);

  @ViewChild('showWorkflowType') showWorkflowType: DialogComponent | any;
  @ViewChild('showWorkflowStageSettings') showWorkflowStageSettings: DialogComponent | any;
  @ViewChild('showAllStageParticipants') showAllStageParticipants: DialogComponent | any;

  /**** FORM GROUP */
  public workflowCreateForm: FormGroup = this.formBuilder.group({
    add_comment: [false],
    visible_for_next_stage: [false],
    deadline_in_days: [0],
    radio_options: [0],
    workflow_comment:[''],
    checkbox_option: [],
    dropdown_choice: ['q2'],
    workflow_text:[''],
    datetime_answer:[''],
    date_asnwer: [''],
    is_simple_accept: true,
    accept_option: [''],
    radio_image_options: [''],
    workflow_stage_title: [''],
    workflow_stage_description: [''],
    workflow_participants_type: ['single'],
    workflow_for_all_users: [''],
    workflow_specific_users:[''],
    return_to_requester:[''],
    end_workflow_silentely:[''],
    workflow_generate_link_requesters: [''],
    search_user_string: [''],
    chat_with_participant: ['']
  });

  editSettings():void{
    alert('Open the Create New Workflow dialog in edit mode');
  }

  onOpenDialog = (event: any, id: string): void => {
    event.preventDefault();
    if (id == 'start-workflowpreview') {

    }

    if(id == 'show-workflowtype')
      {
        this.showWorkflowType.show();
      }

    if(id == 'show-workflowstagesettings')
      {
        this.showWorkflowStageSettings.show();
      }

    if(id == 'show-workflowstageparticipants')
      {
        this.showAllStageParticipants.show();
      }

  }

  closeDialog(id = ""): void {
    if(id == 'show-workflowtype')
    {
      this.showWorkflowType.hide();
    }

    if(id == 'show-workflowstagesettings')
      {
        this.showWorkflowStageSettings.hide();
      }

      if(id == 'show-workflowstageparticipants')
      {
        this.showAllStageParticipants.hide();
      }

  }

  questionHasAttachments = false;
  isStageExpanded = true;
  isReviewerStage=true;
  ticks: object = { placement: 'After', largeStep: 1, smallStep: 0.5, showSmallTicks: true };
  public month: number = new Date().getMonth();
  public fullYear: number = new Date().getFullYear();
  public date: number = new Date().getDate();
  public dateValue: Date = new Date(this.fullYear, this.month , this.date, 10, 0, 0);
  public minValue: Date = new Date(this.fullYear, this.month , this.date, 7, 0, 0);
  public maxValue: Date = new Date(this.fullYear, this.month, this.date, 16, 0 ,0);
  public formatString = 'HH:mm';
  public interval = 15;
  public attachmentFiles: FileStorageResource[] = [];
  dropdown_datasource: any[] = [
    {id: 'st2', name: 'ST.2'},
    {id: 'st3', name: 'ST.3'}
  ];
  accept_datasource: any[] = [
    {id: 'next_stage', name: 'Next stage'},
    {id: 'complete', name: 'Complete Workflow'}
  ];
  rejection_clause_datasource: any[] = [
    {id: 'revision', name: 'Requres revision'},
    {id: 'next_stage', name: 'Next stage'},
    {id: 'complete', name: 'Complete Workflow'}

  ];
  rejected_target: any[] = [
    {id: 'requester', name: 'Requester'},
    {id: 'st3', name: 'Any prev. stage'}
  ];
  showAttachments():void{
    alert("Display a list of attached files like in the news file attachments.");
  }

  toggleExpanded():void{
    this.isStageExpanded = !this.isStageExpanded;
  }

  openFeedbackCreator():void{
    alert("open feedback creator, in single form mode. There should be no Q1. Q2. text, only allow title, description, attachment for the first question")
  }

  close():void{

  }

  selectedStageType: string | null = null;
  defaultText = 'Select a stage type to add to your workflow.';
  hoverText = this.defaultText;

  setStageDescription(stageKey: string) {
    if(stageKey === 'task')
    {
      this.hoverText = "Assign a form or action to one or more users.";
    }else if(stageKey === 'review')
    {
      this.hoverText = "Add an approval step with Accept/Reject logic or custom form.";
    }else{
      this.hoverText = "Ends the workflow. Optionally notifies the requester or completes silently.";
    }
  }

  resetToSelectedDescription() {
    if (this.selectedStageType) {
      this.setStageDescription(this.selectedStageType);
    } else {
      this.hoverText = this.defaultText;
    }
  }

  selectStage(stageKey: string) {
    this.selectedStageType = stageKey;
    this.setStageDescription(stageKey);
  }

  activeStep=0;
  public steps: string[] = [this.languageService.getTranslationByKey('WORKFLOWSTAGEINFOMENUTEXT'), this.languageService.getTranslationByKey('WORKFLOWSTAGEMEMBERSMENUTEXT'),  this.languageService.getTranslationByKey('WORKFLOWSTAGESETTINGSMENU')];

  public participantsUserIDs: number[] = [108];
  public participantsGroupIDs: number[] = [8,6];
  public participantsMails: string[] = [];
  public pushUserIDs: number[] = [];
  pushGroupIDs: number[] = [];

  requesterShowParticipants():void{
    alert("Same popup as in homepage when you click on the participants list in the notifications under the calendar. Search for the title CALPARTICIPANTS");
  }
}
